import { showNotification } from '@mantine/notifications';
import { NotificationType } from '@/types/Common';

export const notify = (type: NotificationType, message: string) => {
  showNotification({
    title:
      type === NotificationType.SUCCESS
        ? 'Sukces'
        : type === NotificationType.INFO
          ? 'Informacja'
          : type === NotificationType.WARNING
            ? 'Ostrzeżenie'
            : 'Błąd',
    message,
    color:
      type === NotificationType.SUCCESS
        ? 'green'
        : type === NotificationType.INFO
          ? 'blue'
          : type === NotificationType.WARNING
            ? 'yellow'
            : 'red',
    autoClose: 5000,
  });
};